import React from 'react';
import { NextPage } from 'next';
import Head from 'next/head';
import { defineMessages, useIntl } from 'react-intl';
import { Footer } from '../../../layouts/Footer';
import { QuestionDetail } from './categories/types';
import { QuestionDetailsList } from './questionDetails/QuestionDetailsList';
import style from './questionDetails/Answers.module.scss';
import { IndexDownloadNow } from '../index/IndexDownloadNow';
import { NavbarComponent } from '../../../layouts/Navbar';

const { pageTitle } = defineMessages({
  pageTitle: {
    id: 'web.questions_detail.page_title',
    defaultMessage: '{text}'
  }
});

export const QuestionDetailsPage: NextPage<{ questionDetails: QuestionDetail }> = React.memo(({ questionDetails }) => {
  const intl = useIntl();
  const description = questionDetails.answers.map((a) => `${a.text} [${a.points}]`).join(' | ');
  return (
    <>
      <Head>
        <title>{intl.formatMessage(pageTitle, { text: questionDetails.text })}</title>
        <meta itemProp="description" content={description} key="itemProp-description" />
        <meta name="description" content={description} key="description" />
        <meta property="og:description" content={description} key="fb-description" />
        <meta property="twitter:description" content={description} key="twitter-description" />
      </Head>
      <NavbarComponent dark />
      <div className="d-flex flex-column">
        <div className={style.answersWrapper}>
          <QuestionDetailsList questionDetails={questionDetails} />
        </div>
      </div>
      <IndexDownloadNow />
      <Footer />
    </>
  );
});
